import { css } from '@leafygreen-ui/emotion';

export const h3Styles = css`
  font-size: 24px;
  line-height: 32px;
  font-weight: 500;
`;
